module.exports = __webpack_public_path__ + "img/39.102e3277.jpg";